import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IPriorityField {
	settingsId: string;
	onChange: (value: string) => void;
}

const PriorityField: React.FC<IPriorityField> = ({ onChange, settingsId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterPriority') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			onChange(onlyDigits);
			return onlyDigits;
		},
		[onChange],
	);

	return (
		<FormInput
			testId="PriorityField"
			name={`priority-${settingsId}`}
			label="priorityLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(PriorityField);
